import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/index.vue'

import TodayHot from './today_hot'
import FutureChance from './future_chance'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Index,
    children: [
      TodayHot,
      FutureChance
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  saveScrollPosition: true,
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    return new Promise(resolve => {
      setTimeout(() => {
        if (savedPosition) {
          return resolve(savedPosition)
        } else {
          return resolve({
            x: 0,
            y: 0
          })
        }
      }, 100)
    })
  },
  routes
})

export default router
